let accessToken = null;

export const tokenService = {
    getAccessToken: () => accessToken,
    setAccessToken: (token) => {
        accessToken = token;
    },
    clearAccessToken: () => {
        accessToken = null;
    },
};
